import * as mt from './mutation-types';
import { VegetationIndexState, VegetationIndexPayload, VegetationIndexCropPayload } from './types'

export default {
  [mt.CLEANUP](state: VegetationIndexState) {
    state.cropStatus = new Map();
    state.averageStatus = new Map();
    state.averageStatusForCropTypeNotConfirmed = new Map();
    state.vegetationIndexAverageContext = new Map();
    state.vegetationIndexAverageForCropTypeNotConfirmedContext = new Map();
    state.vegetationIndexCropsContext = new Map();
  },

  [mt.FETCHING_VEGETATION_INDEX_AVERAGE](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.averageStatus.set(uuid, 'fetching');
    state.averageStatus = new Map(state.averageStatus);
  },
  [mt.FETCH_VEGETATION_INDEX_AVERAGE](state: VegetationIndexState,  { uuid, vegetationIndexAverages}: VegetationIndexPayload) {
    state.vegetationIndexAverageContext.set(uuid, vegetationIndexAverages)
    state.vegetationIndexAverageContext = new Map(state.vegetationIndexAverageContext);
    state.averageStatus.set(uuid, 'fetch');
    state.averageStatus = new Map(state.averageStatus);
  },
  [mt.FETCH_FAILURE](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.averageStatus.set(uuid, 'error');
    state.averageStatus = new Map(state.averageStatus);
  },
  
  [mt.FETCHING_VEGETATION_INDEX_CROP](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.cropStatus.set(uuid, 'fetching');
    state.cropStatus = new Map(state.cropStatus);
  },
  [mt.FETCH_VEGETATION_INDEX_CROP](state: VegetationIndexState, { uuid, vegetationIndexCrop }: VegetationIndexCropPayload) {
    state.vegetationIndexCropsContext.set(uuid, vegetationIndexCrop);
    state.vegetationIndexCropsContext = new Map(state.vegetationIndexCropsContext);
    state.cropStatus.set(uuid, 'fetch');
    state.cropStatus = new Map(state.cropStatus);
  },
  [mt.FETCH_CROP_FAILURE](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.cropStatus.set(uuid, 'error');
    state.cropStatus = new Map(state.cropStatus);
  },

  [mt.FETCHING_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.averageStatusForCropTypeNotConfirmed.set(uuid, 'fetching');
    state.averageStatusForCropTypeNotConfirmed = new Map(state.averageStatusForCropTypeNotConfirmed);
  },
  [mt.FETCH_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED](state: VegetationIndexState,  { uuid, vegetationIndexAverages}: VegetationIndexPayload) {
    state.vegetationIndexAverageForCropTypeNotConfirmedContext.set(uuid, vegetationIndexAverages)
    state.vegetationIndexAverageForCropTypeNotConfirmedContext = new Map(state.vegetationIndexAverageForCropTypeNotConfirmedContext);
    state.averageStatusForCropTypeNotConfirmed.set(uuid, 'fetch');
    state.averageStatusForCropTypeNotConfirmed = new Map(state.averageStatus);
  },
  [mt.FETCH_FAILURE_FOR_CROP_TYPE_NOT_CONFIRMED](state: VegetationIndexState, { uuid }: { uuid: string }) {
    state.averageStatusForCropTypeNotConfirmed.set(uuid, 'error');
    state.averageStatusForCropTypeNotConfirmed = new Map(state.averageStatusForCropTypeNotConfirmed);
  },
};
